module.exports = __webpack_public_path__ + "img/file-dashed-line.aae84f7b.svg";